export default __webpack_public_path__ + "static/media/Pit Fighter's Heretical Eye.2f06408b.jpg";